import React, { useEffect, useState, useRef } from "react";
import './OriginLocation.css';
import OdooService from '../../../services/odooService';
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../../components/ErrorModal/ErrorModal";
import LoadingOverlay from "../../../components/LoadingOverlay/LoadingOverlay";

const OriginLocation = ({ onLocationScanned}) => {
    const navigate = useNavigate();
    const handleBack = () => navigate(-1);
    const [user, setUser] = useState(null);
    const [originLocation, setOriginLocation] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputRef = useRef(null);
    const scanInputRef = useRef(null); 
    const scanTimer = useRef(null);

    useEffect(() => {
        if (scanInputRef.current) {
            scanInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
            if (error === "" && scanInputRef.current) {
                setTimeout(() => {
                    scanInputRef.current.focus();
                }, 50);
            }
        }, [error])

    const handleManualEnter = async (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            const code = inputRef.current.value.trim();

            if (code !== "") {
                await validateAndRedirect(code);
            }

            inputRef.current.value = "";
        }
    };

    const handleScannerChange = (e) => {
        const value = e.target.value;
        setOriginLocation(value);

        if (scanTimer.current) clearTimeout(scanTimer.current);

        if (value.trim() !== "") {
            scanTimer.current = setTimeout(() => {
                validateAndRedirect(value.trim());
            }, 120);
        }
    };

    const handleScannerKeyEvents = (e) => {
        if (e.key === "Backspace" || e.keyCode === 8) return e.preventDefault();
        if (e.key === "BrowserBack" || e.keyCode === 4) return e.preventDefault();
        if (e.key === "Enter" || e.keyCode === 13) return e.preventDefault();
        if (e.key.length > 1) return e.preventDefault();
    };


    const validateAndRedirect = async (barcode) => {
        setLoading(true);
        setError('');

        try {
            const result = await OdooService.validateLocationOrPackage(barcode);
            if (result.success) {
                if (result.type == 'location') {
                    navigate('/addpackages', {
                        state: {
                            location_id: result.location_id,
                            location_name: result.location_name
                        }
                    });
                }

                if (result.type == 'package') {
                    navigate('/addpackages', {
                        state: {
                            location_id: result.location_id,
                            location_name: result.location_name,
                            package_id: result.package_id,
                            package_name: result.package_name
                        }
                    });
                }
            } else {
                setError(result.message);

                setOriginLocation('');
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            }
        } catch (err) {
            setError('Error de conexión: ' + err.message);
            if (inputRef.current) {
                inputRef.current.focus();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="transfer-step-ol">
            <header className="step-header-ol">
                <h1>Transferencia Interna</h1>
                <p>Ubicación Origen</p>
            </header>
            <div className="step-content-ol">
                <div className="form-section-ol">
                    <h2>Escanee el código de la ubicación origen o paquete</h2>
                    <div className="form-group-ol">
                        <input
                            ref={inputRef}
                            type="text"
                            className="form-input-ol"
                            placeholder="Digita el código manualmente"
                            disabled={loading}
                            onKeyDown={handleManualEnter}
                            inputMode="text"
                            onFocus={(e) => e.target.select()}
                        />

                        <input
                            ref={scanInputRef}
                            className="scan-input-ol"
                            type="text"
                            value={originLocation}
                            onChange={handleScannerChange}
                            onKeyDown={handleScannerKeyEvents}
                            autoFocus
                            inputMode="none"
                        />
                    </div>
                </div>
            </div>
            <div className="step-actions-ol">
                <button
                    onClick={handleBack}
                    className="btn-ol btn-secondary-ol"
                    disabled={loading}
                >
                    Volver
                </button>
            </div>

            {loading && <LoadingOverlay message="Cargando..." />}

             <ErrorModal message={error} onClose={() => setError("")} />
        </div>
    );
};

export default OriginLocation;